import { usePage } from "@hooks/usePage";
import { Backdrop, CircularProgress } from "@mui/material";

function LoadingPage() {
  const { isLoading } = usePage();

  return (
    <Backdrop className="z-100" open={isLoading}>
      <CircularProgress size={60} />
    </Backdrop>
  );
}

export default LoadingPage;
